/**
 * One headline figure: a caption, the number, and a line saying what it counts. The KPI strips on
 * the Invoices, Expenses and Reports pages are a wrapping row of these, which is what lets four of
 * them sit side by side on a desktop and stack on a phone.
 */
import type { StackPanel } from 'webwin';
import type { CrmLabel, TextRole } from './Text.js';
import { FONT, GAP, muted, stackOf, value, vstack } from './layout.js';

export interface Stat {
  readonly panel: StackPanel;
  set(amount: string, detail?: string, role?: TextRole): void;
}

export function stat(caption: string, width = 180): Stat {
  const amount: CrmLabel = value('', { font: FONT.h1 });
  const detail: CrmLabel = muted('');
  const panel = stackOf(vstack({ spacing: GAP.xs, width, autoWidth: false }), muted(caption), amount, detail);
  return {
    panel,
    set(next, line = '', role = 'text') {
      amount.text = next;
      amount.role = role;
      detail.text = line;
      detail.visible = line.length > 0;
    }
  };
}
